import { useState, useEffect } from 'react';
import { useForm } from '../../hooks';

import { Typography } from '@mui/material';

import { Button, TextField, Form } from '../common';
import { auth } from '../../utils/api';
import FormSubmitted from './FormSubmitted';
import colors from '../../assets/colors';
import texts from '../../assets/texts';

export default function ResetPasswordForm(props) {
  const { handleChange, values } = useForm({
    password: '',
    passwordConfirmation: '',
  });
  const [infoText, setInfoText] = useState('');
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isFormDataComplete, setIsFormDataComplete] = useState(false);
  const [UUID, setUUID] = useState();

  useEffect(() => {
    setUUID(window.location.href.split('=').pop());
  }, []);

  useEffect(() => {
    if (
      values.password.length > 0 &&
      values.passwordConfirmation.length > 0 &&
      values.password === values.passwordConfirmation
    ) {
      setIsFormDataComplete(true);
    } else {
      setIsFormDataComplete(false);
    }
  }, [
    values.password,
    values.password.length,
    values.passwordConfirmation,
    values.passwordConfirmation.length,
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    auth
      .changePassword(values.password, UUID)
      .then(function () {
        setError(false);
        setSubmitted(true);
      })
      .catch((err) => {
        setError(true);
        if (err.response.data === 'Token not found') {
          setInfoText('Niepoprawny link do zresetowania hasła!');
        } else if (err.response.data === 'Link expired!') {
          setInfoText('Link do zresetowania hasła wygasł!');
        } else {
          setInfoText(err.response.data);
        }
      });
  };

  return (
    <>
      {!submitted ? (
        <>
          <Typography variant="h4" sx={{ mt: 13, fontWeight: 600 }}>
            Utwórz nowe hasło
          </Typography>

          {infoText !== '' && !error && (
            <Typography
              sx={{ color: colors.agroweGreen, mt: 4, fontWeight: 500 }}
            >
              {infoText}
            </Typography>
          )}
          {infoText !== '' && error && (
            <Typography sx={{ color: colors.redError, mt: 4, fontWeight: 500 }}>
              {infoText}
            </Typography>
          )}
          {!error && !isFormDataComplete && values.password.length > 0 && (
            <Typography
              sx={{
                color: colors.redError,
                mt: 4,
                fontWeight: 500,
              }}
            >
              Hasła nie są takie same!
            </Typography>
          )}

          <Form noValidate sx={{ mt: 6 }}>
            <TextField
              login
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="NOWE HASŁO"
              type="password"
              id="password"
              onChange={handleChange('password')}
              error={error}
              helperText={''}
              InputLabelProps={{ shrink: true }}
              inputProps={{ 'data-testid': 'password' }}
            />

            <TextField
              login
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="passwordConfirmation"
              label="POWTÓRZ NOWE HASŁO"
              type="password"
              id="passwordConfirmation"
              onChange={handleChange('passwordConfirmation')}
              error={error}
              helperText={'POLA OZNACZONE * SĄ WYMAGANE'}
              InputLabelProps={{ shrink: true }}
              inputProps={{ 'data-testid': 'repeatPassword' }}
            />

            <Button
              login
              type="submit"
              fullWidth
              variant="outlined"
              size="large"
              disabled={!isFormDataComplete}
              onClick={handleSubmit}
              sx={{ mt: 5 }}
            >
              UTWÓRZ NOWE HASŁO
            </Button>
          </Form>
        </>
      ) : (
        <FormSubmitted
          documentTitle={props.documentTitle}
          title="Hasło zostało pomyślnie zmienione"
          description={texts.passwordChanged}
          buttonText="PRZEJDŹ DO EKRANU LOGOWANIA"
        />
      )}
    </>
  );
}
